import React, { Component } from 'react';
import Page from '../components/Page';
import { Button, Typography, Stack, Grid, ListItem, ListItemText, Card, CardContent, Box, ButtonGroup } from '@mui/material';
//import styled from '@emotion/styled';

const steps = [
	{
		name: 'Start trial',
		return: step1(),
	},
	{
		name: 'Connect phone (Adding phone then read QR)',
		return: step2(),
	},
	{
		name: 'Set webhook',
		return: step3(),
	},
	{
		name: 'Look at documentation',
		return: step4(),
	},
	{
		name: 'Let’s start sending & getting message',
		return: step5(),
	},
	{
		name: 'Finally, subscribe package you need, go on',
		return: step6(),
	},
];

/* const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : 'white',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	border: '1px solid #c7c7c7',
	color: theme.palette.text.secondary,
	alignItems: 'center',
	margin: '30px',
})); */

/* const AccordionItem = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'white',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
})); */

function step1() {
	return (
		<div>
			{/* <Typography>Start Description</Typography> */}
			<Button
				sx={{
					':hover': {
						color: '#fafafa',
						backgroundColor: '#05a06d !important',
					},
					color: 'white',
					background: '#10b981',
					marginTop: '15px',
				}}
				href="/subscription"
			>
				Subscription Page
			</Button>
		</div>
	);
}
function step2() {
	return (
		<div>
			<Typography>Firstly add the phone then read QR.</Typography>
			<Button
				sx={{
					':hover': {
						color: '#fafafa',
						backgroundColor: '#05a06d !important',
					},
					color: 'white',
					background: '#10b981',
					marginTop: '15px',
				}}
				href="/subscription"
			>
				Phone Page
			</Button>
		</div>
	);
}

function step3() {
	return (
		<div>
			<Typography>Set the webhook and check the webhook.</Typography>
			<Button
				sx={{
					':hover': {
						color: '#fafafa',
						backgroundColor: '#05a06d !important',
					},
					color: 'white',
					background: '#10b981',
					marginTop: '15px',
				}}
				href="/developers/webhook"
			>
				Webhook Page
			</Button>
		</div>
	);
}

function step4() {
	return (
		<div>
			<Typography>Look at the documentation page.</Typography>
			<Button
				sx={{
					':hover': {
						color: '#fafafa',
						backgroundColor: '#05a06d !important',
					},
					color: 'white',
					background: '#10b981',
					marginTop: '15px',
				}}
				href="/developers/documentation"
			>
				Documentation Page
			</Button>
		</div>
	);
}

function step5() {
	return (
		<div>
			<Typography>{'Let’s start sending & getting message.'}</Typography>
		</div>
	);
}

function step6() {
	return (
		<div>
			<Typography sx={{ paddingBottom: '10px' }}>
				You must fill in your company information then if you completed company settings then go subscription page.
			</Typography>

			<ButtonGroup>
				<Button
					sx={{
						':hover': {
							color: '#fafafa',
							backgroundColor: '#05a06d !important',
						},
						color: 'white',
						background: '#10b981',
						marginTop: '15px',
					}}
					href="/settings/account#company-get"
				>
					Settings
				</Button>
				<Button
					sx={{
						':hover': {
							color: '#fafafa',
							backgroundColor: '#05a06d !important',
						},
						color: 'white',
						background: '#10b981',
						marginLeft: '15px',
						marginTop: '15px',
					}}
					href="/subscription"
				>
					Subscription
				</Button>
			</ButtonGroup>
		</div>
	);
}

class Survey extends Component {
	render() {
		return (
			<Page>
				<Stack spacing={2} sx={{ marginBottom: '10px', padding: '8px' }}>
					<Typography style={{ fontSize: '18px', background: 'white', textAlign: 'center' }}>Welcome to MAYTAPI get started now!</Typography>
				</Stack>
				<Box sx={{ flexGrow: 1 }}>
					<Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
						{steps.map((item, i) => {
							return (
								<Grid item xs={4} sm={4} md={4} key={'index'}>
									<Card sx={{ background: '#fafafa', margin: '15px', marginBottom: i === steps.length - 1 ? '5px' : '0' }}>
										<CardContent style={{ padding: '0', height: '235px' }}>
											<ListItem alignItems="center" sx={{ display: 'inline-block' }}>
												<ListItemText
													secondary={
														<>
															<Typography sx={{ color: 'gray', fontWeight: '600', fontSize: '20px' }}> {item.name}</Typography>
															<Typography sx={{ display: 'inline' }} component="span" variant="body2" color="text.primary">
																{item.return}
															</Typography>
														</>
													}
												/>
											</ListItem>
										</CardContent>
									</Card>
								</Grid>
							);
						})}
					</Grid>
				</Box>
			</Page>
		);
	}
}

export default Survey;
